import React from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import { Controller } from 'react-hook-form';

/**
 @param {
     import('@mui/material').SwitchProps & {
        name: string;
        control: any;
        rules?: any;
        onChange?: any;
        label?: string;
    }
} param0
 */
const FormSwitch = ({
    name,
    control,
    rules,
    onChange: valueChanged,
    label,
    ...props
}) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
            field: {
                onBlur, onChange, value, ref,
            },
        }) => (
            <FormControlLabel
                label={label || ''}
                control={(
                    <Switch
                        {...props}
                        inputRef={ref}
                        onBlur={onBlur}
                        checked={value ?? false}
                        onChange={(event, checked) => {
                            onChange(event);
                            if (valueChanged) {
                                valueChanged(event, checked);
                            }
                        }}
                    />
                )}
            />
        )}
    />
);

export default FormSwitch;
